import React, { useContext } from 'react';

import { HomeContext } from '../Home';
import { HomeInfo } from '../HomeInfo';

export default function InfoSection() {
    const { info } = useContext(HomeContext);
    return <HomeInfo items={info} />;
}
